import { render, staticRenderFns } from "./dragBox.vue?vue&type=template&id=7be8584a&scoped=true&"
import script from "./dragBox.vue?vue&type=script&lang=js&"
export * from "./dragBox.vue?vue&type=script&lang=js&"
import style0 from "./dragBox.vue?vue&type=style&index=0&id=7be8584a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be8584a",
  null
  
)

export default component.exports